import { createStylesWithTheme } from 'utils/functions';

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    maxHeight: "100dvh",
    padding: "44px 24px 32px 24px",
    overflow: "auto",

  },
  headerLogoHorizontal: {
    minHeight: 42,
    height: 42,
    width: 'auto',
    marginBottom: 64,
  },
  subTitle: {
    marginTop: 24,
    maxWidth:422,
  },

};

export default createStylesWithTheme(styles);